@if (Show) {
  <div id="loginOptions" class="modal" [ngStyle]="{ 'z-index': 1001, display: 'block' }">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="modal-header" [ngStyle]="{
                            'justify-content': 'right',
                            height: '40px',
                            backgroundColor:
                              Merchant$?.webapp_settings?.menu_color || Merchant$?.menu_color,
          'border-bottom': borderStyle,
        }"
      >
        <a (click)="cancelClicked()" id="btnnotification" class="close-icon">
          <i [ngStyle]="{ color: menuBorderColor }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
      </div>
      <div class="modal-body">
        <p [ngStyle]="{
                    color: Merchant$?.webapp_settings?.menu_font_color_allpage,
          }"
        >
          @if (FromMultiOutlet) {
            @if (Merchant$?.custom_login_popup_text) {
              <span>{{ Merchant$?.custom_login_popup_text }}</span>
            } @else {
              <span>To avail of promotions and access all available features please
                login to your toodle account.
                <br />
                If you don't have an account you can create one now - it's easy,
                it takes only a few seconds and once created your account will
                work across the entire toodle ecosystem.</span>
            }
          } @else if (FromSingleOutlet) {
          @if (FromLocationSelection) {
          <span>Want it delivered to your address? <br />
            Just log in or create an account, and add your address so we
            know where to bring your order.</span>
          } @else {
          <span>To avail of promotions and access all available features please
            login to your toodle account.
            <br />
            If you don't have an account you can create one now - it's easy,
            it takes only a few seconds and once created your account will
            work across the entire toodle ecosystem.</span>
          }
          } @else {
          <span>Almost done! To place your order, sign in or create a toodle
            account. <br />Your account works across the entire toodle
            ecosystem, making it easy to access features and potential
            promotions from any toodle merchant.</span>
          }
        </p>
      </div>
      <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
          <button id="btnLogin" class="btn btn-orange-light-theme btn-lg font-size-15" [ngStyle]="{
                                            color:
                                              Merchant$?.webapp_settings?.menu_font_color_homepgae ||
                                              Merchant$?.menu_font_color_homepgae,
                                            backgroundColor:
                                              Merchant$?.webapp_settings?.menu_color || Merchant$?.menu_color,
              border: borderStyle,
            }"
            (click)="redirectToLogin()"
          >
            Login
          </button>

          <button id="btnCreateAccount" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                                            color:
                                              Merchant$?.webapp_settings?.menu_font_color_homepgae ||
                                              Merchant$?.menu_font_color_homepgae,
                                            backgroundColor:
                                              Merchant$?.webapp_settings?.menu_color || Merchant$?.menu_color,
              border: borderStyle,
            }"
            (click)="redirectToCreateAccount()"
          >
            Create account
          </button>

          @if (
          Merchant$.webapp_settings?.guest_access_allowed && !FromFeedback
          ) {
          <button id="btnGuest" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                                                color:
                                                  Merchant$?.webapp_settings?.menu_font_color_homepgae ||
                                                  Merchant$?.menu_font_color_homepgae,
                                                backgroundColor:
                                                  Merchant$?.webapp_settings?.menu_color ||
                                                  Merchant$?.menu_color,
                border: borderStyle,
              }"
              (click)="proceedAsGuest()"
            >
              Proceed as guest
            </button>
          }

          @if (ShowSkipOption) {
          @if (
          Merchant$?.is_login_force != undefined &&
          Merchant$?.is_login_force == false
          ) {
          <button class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" (click)="SkipLogin()" [ngStyle]="{
                                                    color:
                                                      Merchant$?.webapp_settings?.menu_font_color_homepgae ||
                                                      Merchant$?.menu_font_color_homepgae,
                                                    backgroundColor:
                                                      Merchant$?.webapp_settings?.menu_color ||
                                                      Merchant$?.menu_color,
                  border: borderStyle,
                }"
              >
                Skip this for now
              </button>
            }
          }

          <!-- <button id="btnCancel" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2"
                    [ngStyle]="{'color':Merchant$?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':Merchant$?.webapp_settings?.menu_color,'border' :borderStyle}"
                    (click)="cancelClicked();">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
}

@if (loadLogin) {
  <app-popup-login (CloseLoginPopup)="closeLogin()" [ShowLogin]="showLogin"></app-popup-login>
}

@if (showRegister) {
  <div id="registerModal" class="modal" [ngStyle]="{ 'z-index': 1001, display: 'block' }">
    <!-- Modal content -->
    <div class="modal-content" [ngStyle]="{ height: '90%' }">
      <div class="modal-header" [ngStyle]="{
                            'justify-content': 'right',
                            height: '40px',
                            backgroundColor:
                              Merchant$?.webapp_settings?.menu_color || Merchant$?.menu_color,
          'border-bottom': borderStyle,
        }"
      >
        <a
          (click)="closeRegistration()"
          id="btnnotification"
          class="close-icon"
        >
          <i
            [ngStyle]="{ color: menuBorderColor }"
            class="zmdi zmdi-close zmdi-hc-fw"
          ></i>
        </a>
      </div>
      <div [ngStyle]="{ overflow: 'auto' }">
        <app-popup-register (ClosePopup)="closeRegistration()"></app-popup-register>
        </div>
    </div>
  </div>
}

<!-- Getting Guest user details as per the webapp setting flag if flag on then it will required -->
<app-guestlogin [currentMerchant]="Merchant$" (GuestLoginChange)="guestLogin($event)"
  [GuestLogin]="showGuest"></app-guestlogin>